import { httpRequest } from "../../http";
import type { IngestRun } from "@models/IngestRun.model";

/** Archive an unprocessed run (bad upload, wrong file, abandoned presign) so it
 *  drops out of the list and bulk processing. Processed files refuse — the
 *  population reset is the way to unwind loaded data (MPN-1445). */
export class CommandDiscardFile {
  async run(fileId: number): Promise<IngestRun> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${fileId}/discard/`;
    return httpRequest<IngestRun>(url, { method: "POST" });
  }
}
